"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavContext = exports.initialState = void 0;
const react_1 = require("react");
const defaultMessages_1 = require("../constants/defaultMessages");
exports.initialState = {
    messages: defaultMessages_1.defaultMessages,
    activeMenu: "",
    mobileMenuOpen: false,
    searchOpen: false,
    innerMobileActiveMenu: "",
    mobileLocaleOpen: false,
    mobileSigninOpen: false,
};
exports.NavContext = (0, react_1.createContext)({
    state: exports.initialState,
    dispatch: () => {
        /* noop */
    },
});
//# sourceMappingURL=navContext.js.map